// extracted by mini-css-extract-plugin
module.exports = {"content":"_filter_content__2mR0H","content_header":"_filter_content_header__3mQrv","chips":"_filter_chips__2LgZ6","chips_stack":"_filter_chips_stack__3c0HW"};